import { UxIconEnum } from "@imaginelearning/mps-ux-component-library";

export const getk5LessonIcon = (subjectName: string) => {
  let icon;
  switch (subjectName.toLowerCase()) {
    case "math":
      icon = UxIconEnum.K2_MATH;
      break;
    case "reading":
      icon = UxIconEnum.K2_READING;
      break;
    case "science":
    case "abld_science":
      icon = UxIconEnum.ABLD_SCIENCE;
      break;
    default:
      icon = UxIconEnum.CIRCLE_NOTCH;
      break;
  }
  return icon;
};

const getCurrentLessonIcon = (subjectName: string) => {
  let icon;
  switch (subjectName.toLowerCase()) {
    case "math":
      icon = UxIconEnum.MATH_COLOR;
      break;
    case "reading":
      icon = UxIconEnum.READING_COLOR;
      break;
    case "sel":
    case "abld_sel":
      icon = UxIconEnum.SEL;
      break;
    case "abld_math":
      icon = UxIconEnum.ABLD_MATH;
      break;
    case "abld_reading":
      icon = UxIconEnum.ABLD_READING;
      break;
    case "abld_inverted_math":
      icon = UxIconEnum.ABLD_INVERTED_MATH;
      break;
    case "abld_inverted_reading":
      icon = UxIconEnum.ABLD_INVERTED_READING;
      break;
    case "abld_inverted_science":
      icon = UxIconEnum.ABLD_INVERTED_SCIENCE;
      break;
    case "science":
    case "abld_science":
      icon = UxIconEnum.ABLD_SCIENCE;
      break;
    default:
      icon = UxIconEnum.CIRCLE_NOTCH;
      break;
  }
  return icon;
};

export default getCurrentLessonIcon;
